import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGeneralSetting } from '../../services'
import { GeneralSettingQueryKeys } from '@/modules/client-setting/keys'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'

export default function useQueryGetGeneralSetting(
	props?: UseBaseQueryOptions<GetGeneralSettingResponse>,
) {
	return useQuery({
		queryKey: [GeneralSettingQueryKeys.GetGeneralSetting],
		queryFn: () => getGeneralSetting(),
		...props,
	})
}
